import { paymentActionTypes, userActionTypes } from '../actions/types';
import { paymentService } from '../services';
import _ from 'lodash';

export const paymentActions = {
    report,
};

function report(query) {
    return (dispatch, getState) => {
        dispatch(request());

        paymentService.getPaymentsReport(query).then(
            payments => {
                dispatch(success(payments))
            },
            error => dispatch(failure(error, getState().authentication.pendingRefreshingToken)),
        );
    };

    function request() {
        return { type: paymentActionTypes.REPORT_REQUEST };
    }
    function success(payments) {
        return { type: paymentActionTypes.REPORT_SUCCESS, payments };
    }
    function failure(error, pendingRefreshToken) {
        if (error.code === 'invalidToken') {
            if (pendingRefreshToken) {
                return {
                    type: userActionTypes.PENDING_REFRESH_TOKEN,
                    error: error.error,
                };
            } else {
                return { type: userActionTypes.INVALID_TOKEN, error: error.error };
            }
        } else {
            return { type: paymentActionTypes.REPORT_FAILURE, error: error.error };
        }
    }
}